import { getValue, setValue } from "@/utils/storage";

export const getOrCreateUserInfo = () => {
  let name = getValue("livekit_name");
  let identity = getValue("livekit_identity");

  if (!name || !identity) {
    // Generate random suffix (e.g., 6 alphanumeric chars)
    const randomSuffix = Math.random().toString(36).substring(2, 8);
    name = `nut_${randomSuffix}`;
    identity = `nut_id_${randomSuffix}`;

    setValue("livekit_name", name);
    setValue("livekit_identity", identity);
  }

  return { name, identity };
};
